import { getUnifiedValue } from '@src/utility/compositionSettings';

import { TextAreaExtendable } from '../../TextAreaExtendable';
import { ControlFieldLabel } from './ControlField';

import type {
  AITextControlConfiguration,
  ControlRenderProps,
  TextControlConfiguration,
} from '../types';

// PLAT-10920 — an `aiText` control writes an ordinary text property (E2), so
// its hand-editable field IS this control. The panel renders it above the AI
// control, and renders it alone on a surface with no generation wired.
export const TextControl = ({
  control,
  activeElement,
  modifyProperty,
  compositionMeta,
}: ControlRenderProps<
  TextControlConfiguration | AITextControlConfiguration
>) => {
  const { unifiedValue } = getUnifiedValue(
    control,
    activeElement,
    compositionMeta,
  );
  const value = typeof unifiedValue === 'string' ? unifiedValue : '';

  return (
    <>
      <ControlFieldLabel>{control.label}</ControlFieldLabel>
      <TextAreaExtendable
        text={value}
        modifyElement={(text: string) => {
          modifyProperty(control, text);
        }}
      />
    </>
  );
};
